/*
  De beeldkolom van de productpagina.

  Alle opnamen staan in de pagina; een klik op een miniatuur wisselt welke
  zichtbaar is. Er wordt dus geen afbeeldingsbron omgewisseld — dat zou de
  srcset van Shopify doorbreken en bij elke klik opnieuw laden.

  Zonder JavaScript blijft de eerste opname staan en zijn de miniaturen
  zichtbaar maar zonder werking. Dat is beter dan een lege plek.
*/
(function () {
  'use strict';

  function start(galerij) {
    var thumbs = galerij.querySelectorAll('[data-thumb]');
    var shots = galerij.querySelectorAll('[data-shot]');
    if (thumbs.length < 2 || shots.length < 2) return;

    function toon(index) {
      for (var i = 0; i < shots.length; i++) {
        var aan = shots[i].getAttribute('data-shot') === String(index);
        shots[i].classList.toggle('is-actief', aan);
      }
      for (var j = 0; j < thumbs.length; j++) {
        var gekozen = thumbs[j].getAttribute('data-thumb') === String(index);
        thumbs[j].classList.toggle('is-actief', gekozen);
        thumbs[j].setAttribute('aria-selected', gekozen ? 'true' : 'false');
      }
    }

    for (var k = 0; k < thumbs.length; k++) {
      (function (knop) {
        knop.addEventListener('click', function () {
          toon(knop.getAttribute('data-thumb'));
        });

        /*
          Pijltjes horen bij een tablist: links en rechts, of boven en onder,
          want de kolom staat rechtop op een breed scherm.
        */
        knop.addEventListener('keydown', function (e) {
          var stap = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') stap = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') stap = -1;
          if (!stap) return;
          e.preventDefault();
          var nu = parseInt(knop.getAttribute('data-thumb'), 10);
          var volgende = (nu + stap + thumbs.length) % thumbs.length;
          toon(volgende);
          thumbs[volgende].focus();
        });
      })(thumbs[k]);
    }
  }

  /*
    De kolom met miniaturen op een breed scherm. Er passen er zoveel in beeld
    als de sectie zegt; twee pijlen schuiven er doorheen, één miniatuur per
    klik. Past alles al, dan verdwijnen de pijlen. Op een telefoon is dezelfde
    rij een liggend strookje en valt er niets te schuiven.
  */
  function kolom(vak) {
    var rail = vak.querySelector('[data-pdp-rail]');
    var terug = vak.querySelector('[data-pdp-mini-terug]');
    var verder = vak.querySelector('[data-pdp-mini-verder]');
    if (!rail || !terug || !verder) return;

    var inbeeld = parseInt(vak.getAttribute('data-inbeeld'), 10);
    if (!inbeeld || inbeeld < 1) inbeeld = 4;

    function kolomstand() {
      return window.matchMedia('(min-width: 1200px)').matches;
    }

    function hoogte() {
      if (!kolomstand()) {
        rail.style.maxHeight = '';
        return;
      }
      var aantal = Math.min(inbeeld, rail.children.length);
      if (aantal < 1) return;
      var gat = parseFloat(window.getComputedStyle(rail).rowGap) || 0;
      var totaal = gat * (aantal - 1);
      for (var i = 0; i < aantal; i++) {
        totaal += rail.children[i].getBoundingClientRect().height;
      }
      if (totaal > 0) rail.style.maxHeight = Math.round(totaal) + 'px';
    }

    function stap() {
      var eerste = rail.firstElementChild;
      if (!eerste) return 0;
      var gat = parseFloat(window.getComputedStyle(rail).rowGap) || 0;
      return eerste.getBoundingClientRect().height + gat;
    }

    function ververs() {
      var ruimte = rail.scrollHeight - rail.clientHeight;
      var schuifbaar = ruimte > 1;
      terug.hidden = !schuifbaar;
      verder.hidden = !schuifbaar;
      if (!schuifbaar) return;
      terug.disabled = rail.scrollTop <= 1;
      verder.disabled = rail.scrollTop >= ruimte - 1;
    }

    var loopt = null;

    function schuif(richting) {
      var afstand = stap() * richting;
      if (!afstand) return;
      var van = rail.scrollTop;
      var naar = Math.max(0, Math.min(rail.scrollHeight - rail.clientHeight, van + afstand));
      if (naar === van) return;
      if (loopt) window.cancelAnimationFrame(loopt);

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rail.scrollTop = naar;
        ververs();
        return;
      }

      var begin = 0;
      var duur = 240;

      function beweeg(nu) {
        if (!begin) begin = nu;
        var deel = Math.min(1, (nu - begin) / duur);
        var soepel = deel < 0.5 ? 2 * deel * deel : -1 + (4 - 2 * deel) * deel;
        rail.scrollTop = van + (naar - van) * soepel;
        if (deel < 1) {
          loopt = window.requestAnimationFrame(beweeg);
        } else {
          rail.scrollTop = naar;
          loopt = null;
          ververs();
        }
      }

      loopt = window.requestAnimationFrame(beweeg);
    }

    terug.addEventListener('click', function () { schuif(-1); });
    verder.addEventListener('click', function () { schuif(1); });

    var wacht = false;
    rail.addEventListener('scroll', function () {
      if (wacht) return;
      wacht = true;
      window.requestAnimationFrame(function () {
        wacht = false;
        ververs();
      });
    });

    function meten() {
      hoogte();
      ververs();
    }

    window.addEventListener('resize', meten);

    var beelden = rail.querySelectorAll('img');
    for (var b = 0; b < beelden.length; b++) {
      if (beelden[b].complete) continue;
      beelden[b].addEventListener('load', meten);
    }

    meten();
    window.addEventListener('load', meten);
  }

  /*
    De puntjes onder de veegrail op een telefoon. Ze hangen aan de scroll van
    de rail: een teller die niet meebeweegt is slechter dan geen teller.
  */
  function puntjes(galerij) {
    var rail = galerij.querySelector('[data-pdp-rail]');
    var vak = galerij.querySelector('[data-pdp-punten]');
    if (!rail || !vak || vak.children.length) return;

    var items = rail.children.length;
    if (items < 2) return;

    for (var i = 0; i < items; i++) {
      var punt = document.createElement('span');
      punt.className = 'pdp__punt' + (i === 0 ? ' is-actief' : '');
      vak.appendChild(punt);
    }

    var wacht = false;
    rail.addEventListener('scroll', function () {
      if (wacht) return;
      wacht = true;
      window.requestAnimationFrame(function () {
        wacht = false;
        if (!rail.clientWidth) return;
        var bij = Math.round(rail.scrollLeft / rail.clientWidth);
        for (var i = 0; i < vak.children.length; i++) {
          vak.children[i].classList.toggle('is-actief', i === bij);
        }
      });
    });
  }

  /*
    De rail begint bij de eerste foto. Zonder dit blijft een browser soms hangen
    op de plek van een vorig bezoek, of schuift de rail mee terwijl de foto's
    binnenkomen -- en dan opent de pagina op foto zes.
  */
  /*
    Op een telefoon is de rail zo hoog als de hoogste foto. Staat er een
    vierkante opname tussen staande, dan blijft daaronder een gat van een paar
    honderd pixels staan. Daarom volgt de hoogte de foto die in beeld is.
  */
  function hoogteVolgtFoto(galerij) {
    var vak = galerij.querySelector('[data-pdp-minivak]');
    var rail = galerij.querySelector('[data-pdp-rail]');
    if (!vak || !rail) return;

    function railstand() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function meet() {
      if (!railstand()) {
        vak.style.height = '';
        return;
      }
      var breedte = rail.clientWidth;
      if (!breedte) return;

      /*
        Alleen meten als de rail stilstaat op een beeld. Midden in een veeg de
        hoogte veranderen laat de browser opnieuw zijn kleefpunt zoeken, en dan
        blijft hij tussen twee beelden hangen.
      */
      var rest = rail.scrollLeft % breedte;
      if (rest > 2 && rest < breedte - 2) return;

      var bij = Math.round(rail.scrollLeft / breedte);
      var kind = rail.children[bij] || rail.firstElementChild;
      if (!kind) return;
      var hoog = kind.getBoundingClientRect().height;
      if (hoog > 0) vak.style.height = Math.round(hoog) + 'px';
    }

    var klaar = null;
    rail.addEventListener('scroll', function () {
      if (klaar) window.clearTimeout(klaar);
      klaar = window.setTimeout(meet, 120);
    });

    window.addEventListener('resize', meet);

    var beelden = rail.querySelectorAll('img');
    for (var i = 0; i < beelden.length; i++) {
      if (beelden[i].complete) continue;
      beelden[i].addEventListener('load', meet);
    }

    meet();
    window.addEventListener('load', meet);
  }

  function beginBijHetBegin(galerij) {
    var rail = galerij.querySelector('[data-pdp-rail]');
    if (!rail) return;
    function terug() { rail.scrollLeft = 0; }
    terug();
    window.addEventListener('load', terug);
  }

  function alles(wortel) {
    var vlakken = (wortel || document).querySelectorAll('[data-galerij]');
    for (var i = 0; i < vlakken.length; i++) {
      start(vlakken[i]);
      puntjes(vlakken[i]);
      beginBijHetBegin(vlakken[i]);
      hoogteVolgtFoto(vlakken[i]);
    }

    var vakken = (wortel || document).querySelectorAll('[data-pdp-minivak]');
    for (var j = 0; j < vakken.length; j++) kolom(vakken[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(); });
  } else {
    alles();
  }

  /* In de theme editor wordt een sectie opnieuw ingevoegd zonder herladen. */
  document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
})();
